import { Component, OnInit } from '@angular/core';
import { ApiUrlUtil } from 'src/app/util/api-url-util';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

@Component({
  selector: 'app-button-baseboard',
  templateUrl: './button-baseboard.component.html',
  styleUrls: ['./button-baseboard.component.scss']
})
export class ButtonBaseboardComponent implements OnInit {

  constructor(private googleAnalitycsService: AnalyticsService) { }

  ngOnInit(): void {
  }

  showDefault() {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_FLOATING,
        'Signer_Flutuante_WhatsApp'
      )
    );

    ApiUrlUtil.goToWhatsApp();
  }
}
